<template>
	<div class="bg-surface-1 rounded-lg px-3 py-2.5 ring-1 ring-white/[0.05]">
		<p class="text-[10px] font-semibold uppercase tracking-wider text-surface-6 mb-1.5">Recommended encoder settings</p>
		<div class="flex flex-wrap items-center gap-x-5 gap-y-1 text-tiny">
			<span v-for="item in settings" :key="item.label">
				<span class="text-surface-6">{{ item.label }}</span>
				<span class="text-white font-medium ml-1.5">{{ item.value }}</span>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SubSecondRecommendedSettings',
	data() {
		return {
			settings: [
				{ label: 'Bitrate', value: '2000 kbps' },
				{ label: 'Keyframe', value: '2s, aligned' },
				{ label: 'Rate control', value: 'CBR' },
				{ label: 'Tune', value: 'Zero Latency' },
				{ label: 'Profile', value: 'Baseline' },
			],
		}
	},
};
</script>

<style scoped></style>
